var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavedJobIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.427,
    height: 18.381,
    viewBox: "0 0 13.427 18.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bookmark",
    d: "M37.925,0H27.6a1.6,1.6,0,0,0-1.579,1.56V17.337a1.238,1.238,0,0,0,.2.7.765.765,0,0,0,.638.343,1.133,1.133,0,0,0,.732-.319l4.619-4.051a.892.892,0,0,1,1.121,0l4.6,4.05a1.094,1.094,0,0,0,.714.319c.405,0,.8-.323.8-1.044V1.56A1.553,1.553,0,0,0,37.925,0Z",
    transform: "translate(-26.022)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedJobIcon);
export default __webpack_public_path__ + "static/media/Saved_Job_icon.43db5be5c66eef076b48d11507ba6f33.svg";
export { ForwardRef as ReactComponent };